import React from "react";
import DialogList from "../SecComponents/dialogList";

const availableReferences = {
  default: {
    message: "Por favor, indique alguna de las referencias:",
    optionList: [
      "Referencia",
      "HBL/HAWB (Documento de Transporte)",
      "Número de Contenedor",
      "Referencia de Cliente",
      "DO (Número de Embarque)",
    ],
  },
  Transporte: {
    message: "Por favor, indique alguna de las referencias:",
    optionList: ["No. Solicitud", "Doc. Transporte"],
  },
};

function HandleType(props) {
  console.log(props);
  return (
    <div className="row" style={{ width: "100%" }}>
      <DialogList
        references={
          props.steps.problemaOperacionMenu.value &&
          props.steps.problemaOperacionMenu.value[0] === "Transporte"
            ? availableReferences["Transporte"]
            : availableReferences["default"]
        }
      />
    </div>
  );
}

export default HandleType;
